let state = {
  userInfo: {
    // uid
    user_id: null,
    // 用户姓名
    username: '',
    // 头像
    avatar: '',
    // 性别
    gender: null,
    // 身份
    role: null,
    // 是否关注公众号
    wechat_subscribe: null,
    // rong cloud token
    token: '',
    // 微信openid
    user_token: '',
    // 用户状态
    status: 0,
    // 医生状态
    doc_status: 0,
    // 医生的医事服务费
    doc_money: 0,
    // 患者是否绑定过医生
    hasDoctor: 0,
    // 医生类型：1.中医 2.西医
    doctor_type: 1,
  },
  uploadParams: {
    host: '',
    policyBase64: '',
    accessid: '',
    signature: '',
    expire: '',
    callback: '',
    key: '',
  },
  // 客服联系电话
  servicePhone: '0951-7871669',
  // 微信SDK是否开启debug
  wechatDebug: false,
  // 聊天列表
  chatList: [],
  // 开处方的临时数据
  prescriptionData: null,
  // 开处方时编辑药品的临时数据
  herbsData: [],
}

export default state;



// WEBPACK FOOTER //
// ./src/vuex/state.js